<template>
  <div>
    <b-table striped hover responsive head-variant="dark" :items="datas" :fields="allFields">
        <template #cell(question)="data">
            <span v-html="data.value"></span>
        </template>
        <template #cell(a)="data">
            <span v-html="data.value"></span>
        </template>
        
        <template #cell(subject)="data">
            <router-link :to="{name : module == 'thirdparty' ? 'questionsfororg' : 'questionsfor', params : { identity : data.value }, query : { institution_id: data.item.institution_id, module : module, category: data.item.category, type : 'subject', clearance : clearance, stocker : data.item.stockertid, source : 'admin', course: '',section : '', subject : data.item.subject, subtype : ''} }">{{ data.value }}</router-link>
        </template>

        <!-- <template #cell(course)="data">
            <router-link :to="{name : module == 'thirdparty' ? 'questionsfororg' : 'questionsfor', params : { identity : data.value }, query : { institution_id: data.item.institution_id, module : module,  category: data.item.category, type : 'course', clearance : clearance, stocker : data.item.stockertid, source : 'admin' , course : data.item.course, subject : '', subtype : ''} }">{{ data.value }}</router-link>
        </template> -->

        <template #cell(section)="data">
          <router-link :to="{name : module == 'thirdparty' ? 'questionsfororg' : 'questionsfor', params : { identity : data.item.course }, query : { institution_id: data.item.institution_id, module : module,  category: data.item.category, type : 'course', clearance : clearance, stocker : data.item.stockertid, source : 'admin' , course : data.item.course, section : data.item.section, subject : '', subtype : ''} }">{{ data.value }}</router-link>
      </template>

        <template #cell(topic_for)="data">
            <router-link :to="{name : 'topicsfor', params : { identity : data.value }, query : { institution: data.item.institution, category: data.item.category} }">{{ data.value }}</router-link>
        </template>

        <template v-if="!hideAction" #cell(action)="data">
          <div style="cursor:pointer;">
            <b-icon-three-dots-vertical
              :id="`popover-1-table-ts${data['S/N']}`"
              variant="primary"
            ></b-icon-three-dots-vertical>
            <b-popover
              :target="`popover-1-table-ts${data['S/N']}`"
              placement="bottomright"
              title=""
              triggers="hover focus"
            >
              <div style="width: 170px; min-height: 40px" class="">
                <div
                  @click="
                    $router.push({name : module == 'thirdparty' ? 'questionsfororg' : 'questionsfor', params : { identity : data.item.institution_structure == 'Subject' ? data.item.subject : data.item.section  }, query : { institution_id: data.item.institution_id, module : module, category: data.item.category, type : data.item.institution_structure == 'Subject' ? 'subject' : 'course', clearance : clearance, stocker : data.item.stockertid, source : 'admin', course: '',section : '', subject : data.item.subject, subtype : ''} })
                  "
                  class="cursor-pointer action-link p-1 px-2"
                >
                  <p class="text-sm">View All Questions</p>
                </div>
              </div>
            </b-popover>
          </div>
        </template>

    </b-table>
    
  </div>
</template>

<script>
//import MathJax from "mathjax"
//import '@/assets/mathjax/es5/tex-chtml.js'

export default {
  props: {
    datas: Array,
    fields: Array,
    clearance : Number,
    module : {
      type: String,
      default : "base"
    },
    hideAction: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    this.allFields = [ ...this.fields, 'action']
  },

  data() {
    return {
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      allFields: []
    };
  },
  watch: {
    fields(newval){
      console.log(newval)
      this.allFields = [ ...newval, 'action']
    }
  },
  methods: {
    showMore() {
      let newend = this.endnum + this.intervalnum;

      if (newend < this.endss) {
        this.endnum = newend;
      } else {
        this.endnum = this.limitnum;
      }
    },
  },

  computed: {
    usedatas() {
      return this.datas.slice(0, this.endnum);
    },
    endss() {
      let end = this.datas.length;
      return end;
    },
  },
};
</script>

<style scoped>
.allrewr {
  min-height: 70vh;
  background-color: white;
  border-radius: 20px 20px;
}

.fhe {
  background-color: #00377b;
  color: white;
  border-radius: 20px 20px 0px 0px;
  font-weight: bold;
}

.viewmore {
  background-color: rgb(241, 234, 234);
  border-radius: 100px;
  width: 50px;
  height: 50px;
  margin: 0px auto;
  box-shadow: 5px 5px 15px black;
  cursor: pointer;
}

.vmore {
  margin: 5px;
  padding: 10px;
}
</style>
